import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';

type Props = {
  onValid: Function;
};

type State = {
  isDisplayed: boolean;
};

export class Banner extends React.Component<Props, State> {
  state: State = {
    isDisplayed: true,
  };

  onClick = () => {
    const { onValid } = this.props;

    this.setState({ isDisplayed: false });
    onValid(() => {
      doctrineAnalytics('Account CookieBannerClosed');
    });
  };

  render() {
    const { isDisplayed } = this.state;

    return (
      isDisplayed && (
        <div className="cookies-banner">
          <div className="cookies-banner__container">
            <p className="cookies-banner__message">
              <FormattedMessage id="cookies/components/banner/Banner.tsx/1" />{' '}
              <Hyperlink
                className="cookies-banner__link"
                href="/cookies"
                source="cookies-banner-edit"
              >
                <FormattedMessage id="cookies/components/banner/Banner.tsx/2" />
              </Hyperlink>{' '}
              <FormattedMessage id="cookies/components/banner/Banner.tsx/3" />{' '}
              <Hyperlink
                className="cookies-banner__link"
                href="/cookies"
                source="cookies-banner-page"
              >
                <FormattedMessage id="cookies/components/banner/Banner.tsx/4" />
              </Hyperlink>
              <FormattedMessage id="cookies/components/banner/Banner.tsx/5" />
            </p>
            <div className="cookies-banner__actions">
              <button
                type="button"
                className="cookies-banner__button button small hollow secondary"
                onClick={this.onClick}
              >
                <FormattedMessage id="cookies/components/banner/Banner.tsx/6" />
              </button>
            </div>
          </div>
        </div>
      )
    );
  }
}
